/* ============================================================
 * AYU Impressum Page
 * AYU Healthtech LIMITED – 128 City Road, London, EC1V 2NX
 * ============================================================ */
import { IMAGES } from "@/lib/constants";
import { useEffect } from "react";

export default function Impressum() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen" style={{ background: "oklch(0.97 0.005 80)" }}>
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[oklch(0.97_0.005_80/0.95)] backdrop-blur-md shadow-sm py-3">
        <div className="container flex items-center justify-between">
          <a href="/" className="flex items-center gap-3">
            <img src={IMAGES.logo} alt="AYU" className="h-10 w-auto" />
          </a>
          <a href="/" className="text-sm text-[oklch(0.52_0.09_128)] font-medium hover:underline" style={{ fontFamily: "var(--font-body)" }}>
            ← Zurück zur Startseite
          </a>
        </div>
      </nav>

      {/* Content */}
      <main className="pt-28 pb-20">
        <div className="container max-w-3xl">
          <h1 className="text-3xl sm:text-4xl font-bold text-[oklch(0.2_0.02_80)] mb-8">
            Impressum
          </h1>

          <div className="space-y-8 text-[oklch(0.35_0.02_80)] leading-relaxed" style={{ fontFamily: "var(--font-body)" }}>
            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">Angaben gemäß § 5 TMG</h2>
              <p>
                AYU Healthtech LIMITED<br />
                128 City Road<br />
                London, United Kingdom<br />
                EC1V 2NX
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">Unternehmensform</h2>
              <p>
                Private Limited Company<br />
                Status: Active
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">Vertreten durch</h2>
              <p>
                Annam Hanfstein, Director<br />
                Chris Hanfstein, Director
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">Kontakt</h2>
              <p>
                E-Mail: <a href="mailto:office@ayu-rveda.ai" className="text-[oklch(0.52_0.09_128)] hover:underline">office@ayu-rveda.ai</a><br />
                Website: <a href="https://www.ayu-rveda.com" className="text-[oklch(0.52_0.09_128)] hover:underline" target="_blank" rel="noopener noreferrer">www.ayu-rveda.com</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">Haftungsausschluss</h2>
              <h3 className="font-bold text-[oklch(0.25_0.02_80)] mb-2">Haftung für Inhalte</h3>
              <p className="mb-4">
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>

              <h3 className="font-bold text-[oklch(0.25_0.02_80)] mb-2">Haftung für Links</h3>
              <p className="mb-4">
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>

              <h3 className="font-bold text-[oklch(0.25_0.02_80)] mb-2">Urheberrecht</h3>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[oklch(0.2_0.02_80)] mb-3">Medizinischer Hinweis</h2>
              <p>
                AYU ist ein präventives Lifestyle-System und ersetzt keine ärztliche Beratung, Diagnose oder Behandlung. Die bereitgestellten Informationen und Empfehlungen dienen ausschließlich der allgemeinen Gesundheitsförderung und Prävention. Bei gesundheitlichen Beschwerden konsultieren Sie bitte einen Arzt oder qualifizierten Gesundheitsdienstleister.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 border-t border-[oklch(0.9_0.01_80)]">
        <div className="container flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-xs text-[oklch(0.5_0.02_80)]" style={{ fontFamily: "var(--font-body)" }}>
            © {new Date().getFullYear()} AYU Healthtech LIMITED. Alle Rechte vorbehalten.
          </span>
          <div className="flex items-center gap-6">
            <a href="/" className="text-xs text-[oklch(0.5_0.02_80)] hover:text-[oklch(0.52_0.09_128)] transition-colors" style={{ fontFamily: "var(--font-body)" }}>Startseite</a>
            <a href="/datenschutz" className="text-xs text-[oklch(0.5_0.02_80)] hover:text-[oklch(0.52_0.09_128)] transition-colors" style={{ fontFamily: "var(--font-body)" }}>Datenschutz</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
